import React from "react";
import { getInventorySignClassName } from "../inventorySignStyles";

const InventoryProfitValue = ({ profit, formatAmount }) => {
  const numericProfit = parseFloat(profit) || 0;
  const isPositive = numericProfit >= 0;
  const displayAmount = formatAmount(Math.abs(numericProfit));

  return (
    <span className={getInventorySignClassName(isPositive)}>
      {isPositive ? "+" : "-"}
      {displayAmount}
    </span>
  );
};

export default InventoryProfitValue;
